import { t } from 'i18next';
import * as yup from 'yup';

import { createOtpCodeSchema } from 'core/components/form';

export const changePinCodeSchema = yup
  .object({
    oldPin: createOtpCodeSchema({
      size: 4,
      name: t('pages.settings.changePinForm.fields.oldPin.name'),
    }),
    newPin: createOtpCodeSchema({
      size: 4,
      name: t('pages.settings.changePinForm.fields.newPin.name'),
    }),
    confirmNewPin: createOtpCodeSchema({
      size: 4,
      name: t('pages.settings.changePinForm.fields.confirmNewPin.name'),
    }).oneOf([yup.ref('newPin')], t('errors.validation.pinCode.match')),
  })
  .required();

export type ChangePinCodeFormData = yup.InferType<typeof changePinCodeSchema>;
